
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumbs from '../breadCrumbs'
import { useEffect } from 'react';
import { retrunAssets } from '../../utils/getAssets';
import { fetchScholarshipsAssetsData } from '../../redux/slice/finAidScholarshipAssetsPage';

const Banner = () => {
    const dispatch = useDispatch()
    const state = useSelector(state => state.scholarshipsAssets)
    useEffect(()=>{
        if(state?.data === null){
            dispatch(fetchScholarshipsAssetsData("scholarships"))
        }
    },[state,dispatch])

    const name = state?.data?.properties?.title
    const bg = state?.data?.properties?.backgroundImage !== null ? retrunAssets(state?.data?.properties?.backgroundImage[0]?.url) : ""

    return (

        <div className="relative h-[30vh] md:h-[70vh]  bg-center  overflow-hidden bg-cover  bg-no-repeat " style={{backgroundImage:`url('${bg}')`}}>
            <div className="absolute inset-0  bg-[rgba(0,0,0,0.2)]"></div>


            <div className="absolute top-1/2  gap-3 flex flex-col items-center left-1/2 -translate-x-1/2 transition-all">
                <h1 className="text-3xl md:text-5xl lg:text-[4rem] whitespace-nowrap font-bold text-white transition-all">{name}</h1>
                <BreadCrumbs />
            </div>
        </div>

    )
}

export default Banner